import { Dialog } from "@material-ui/core";
import "./style.scss";
import {Wallets} from "../../../helpers/WalletList";
import LogoComponent from "../LogoComponent";

// Import Icons
import InfoIcon from "../../../assets/icons/info.svg";
import { useDispatch } from "react-redux";
import { setProvider } from "redux/state";





const LoginDialog = ({open, onClose}) => {

  const dispatch = useDispatch();

  const selectWallet = (wallet) => {
    localStorage.setItem("provider", wallet.provider);
    dispatch(setProvider(wallet.provider));
    onClose();
  }

  return <Dialog
    classes={{ root: "popup_container", paper: "loginDialog" }}
    aria-labelledby="simple-dialog-title"
    open={open}
    onClose={onClose}
  >
    <LogoComponent height={30}/>
    <p className="title">
      Please connect wallet to start using PRISM DEX
    </p>
    <p className="howTo">
      Next time, we will automatically try to connect to the same wallet
    </p>
    <a rel="noreferrer" target="_blank" href="https://discord.gg/prism-ag" className="howTo"> 
      Need Help? Ask on Discord
      <span>
        <img alt="Need help?" src={InfoIcon} height={15}/>
      </span> 
    </a>
    <div className="walletSelector">
      {
        Wallets.map((wallet, i) => {
          return <div key={i} className="walletOption" onClick={() => selectWallet(wallet)}>
              <img alt="Wallet" src={wallet.icon} height={30}/>
              <div className="walletInfo">
                <p className="name">
                  {
                    wallet.name
                  }
                </p>
                <p className="url">
                  {
                    wallet.url
                  }
                </p>
              </div>
            </div>
        })
      }
    </div>
  </Dialog>
}

export default LoginDialog;

